<template lang="pug">
span.root
  slot(name="default", :results="results", :reloading="reloading")
    TransitionNavigate
      slot(name="loader", v-if="reloading", :reloading="reloading")
        SearchLoader
      .search__results(v-else-if="results.length")
        template(v-if="results" v-for="result in results")
          slot(
            name="item",
            :result="result",
            :openInNewWindow="config.openInNewWindow",
            :formatDate="formatDate"
          )
            Item(
              :result="result",
              :openInNewWindow="config.openInNewWindow",
              :formatDate="formatDate"
            )
      template(v-else)
        slot(name="empty", :noResultsText="config.noResultsText")
          p.search__results-empty(v-html="config.noResultsText")
</template>

<script>
import TransitionNavigate from "../../transitions/Navigate.vue";
import SearchLoader from "../loader/Loader.vue";
import Item from "./Item.vue";
import { format } from "date-fns";

export default {
  name: "BlueResults",
  components: { TransitionNavigate, SearchLoader, Item },
  props: [],
  data() {
    return {};
  },
  computed: {
    results() {
      return this.$store.getters.results.itemResults;
    },
    reloading() {
      if (this.config.transitionOnReload) return this.$store.getters.reloading;
      else return false
    },
  },
  methods: {
    formatDate(date, formatPattern) {
      return format(new Date(date), formatPattern);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
span.root {
  display: contents;
}
.search__results {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  &-empty {
    font-style: italic;
    margin: 2rem;
    text-align: center;
  }
}
</style>